export default __webpack_public_path__ + "static/media/demat.28457780.png";